












import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'oj-iter',
})
export default class OJIter extends Vue { }
